/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EntityContext
 */
export interface EntityContext {
    /**
     * 
     * @type {string}
     * @memberof EntityContext
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityContext
     */
    firstSeen?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityContext
     */
    lastSeen?: string;
}

/**
 * Check if a given object implements the EntityContext interface.
 */
export function instanceOfEntityContext(value: object): value is EntityContext {
    return true;
}

export function EntityContextFromJSON(json: any): EntityContext {
    return EntityContextFromJSONTyped(json, false);
}

export function EntityContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityContext {
    if (json == null) {
        return json;
    }
    return {
        
        'source': json['source'] == null ? undefined : json['source'],
        'firstSeen': json['firstSeen'] == null ? undefined : json['firstSeen'],
        'lastSeen': json['lastSeen'] == null ? undefined : json['lastSeen'],
    };
}

export function EntityContextToJSON(json: any): EntityContext {
    return EntityContextToJSONTyped(json, false);
}

export function EntityContextToJSONTyped(value?: EntityContext | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'source': value['source'],
        'firstSeen': value['firstSeen'],
        'lastSeen': value['lastSeen'],
    };
}

